import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../input/input';
import { Box, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const SuggestionInput = (props) => {
    const [focusData, setFocusData] = useState(false);
    const [showAll, setShowAll] = useState(false); // New state for showing all suggestions
    const boxRef = useRef(null);
    const [filterData, setFilterData] = useState([]);
    const [updatedValue, setUpdatedValue] = useState("");

    function handleInputChange(e) {
        const inputValue = e.target.value.toLowerCase();
        filterSuggestions(inputValue);
        setUpdatedValue(e.target.value);
        if (props.simple !== 'true') {
            props.handleInputChange?.(e);
        }
    }

    function filterSuggestions(inputValue = "") {
        const filtered = props?.Suggestions?.filter(item => 
            item.supplier_name?.toLowerCase().includes(inputValue) ||
            item.contact_person?.toLowerCase().includes(inputValue) ||
            item.phone_number?.toLowerCase().includes(inputValue)
        );
        setFilterData(filtered);
    }

    function toggleShowAll() {
        setShowAll(!showAll);
        if (!showAll) {
            // When showing all, reset the filter
            filterSuggestions();
            setFocusData(true);
        }
    }

    function getValue(selectedItem) {
        const value = `${selectedItem.supplier_id}, ${selectedItem.supplier_name}, ${selectedItem.phone_number}`;
        setUpdatedValue(value);
        setFocusData(false);
        setShowAll(false);
        const event = {
            target: {
                value,
                name: props.name
            }
        };
        props.handleInputChange?.(event);
    }

    useEffect(() => {
        const handleMouseDown = (event) => {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                setFocusData(false);
                setShowAll(false);
            }
        };
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, []);

    return (
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <Input
                onChange={handleInputChange}
                onFocus={() => setFocusData(true)}
                sx={{ maxWidth: '556px', flex: 1 }}
                required
                name={props.name}
                placeholder={props.placeholder}
                value={updatedValue}
                autoComplete="off"
            />
            <IconButton 
                onClick={toggleShowAll}
                sx={{ 
                    position: 'absolute', 
                    right: '8px',
                    color: 'action.active',
                }}
            >
                <ArrowDropDownIcon />
            </IconButton>
            
            {(filterData.length > 0 && (focusData || showAll)) && (
                <Box
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        top: '100%',
                        maxWidth: '556px',
                        boxShadow: '0px 5px 11px 0px #d7d7d7',
                        zIndex: 6,
                        background: 'white',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        mt: 1
                    }}
                    ref={boxRef}
                >
                    {filterData.map((item, ind) => (
                        <Box
                            className='fontSizing'
                            key={ind}
                            onClick={() => getValue(item)}
                            sx={{
                                padding: '10px',
                                cursor: 'pointer',
                                zIndex: 6,
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            {`${item.supplier_id}, ${item.supplier_name},  ${item.phone_number}`}
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

SuggestionInput.propTypes = {
    Suggestions: PropTypes.arrayOf(PropTypes.object),
    handleInputChange: PropTypes.func,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    simple: PropTypes.string,
};

export default SuggestionInput;